const CREATED = 1;
const APPROVED = 2;
const ACTIVE = 3;
const INACTIVE = 4;
const REJECTED = 5;
const CANCELED = 6;
const PENDING = 7;

export default {
  CREATED,
  APPROVED,
  ACTIVE,
  INACTIVE,
  REJECTED,
  CANCELED,
  PENDING
};
